<template>
  <div class="lastArticlesContainer">
    <v-toolbar class="categoriesHeader" elevation="0"
    >
      <v-icon @click="goBack">
        mdi-chevron-left
      </v-icon>


      <v-toolbar-title class="pageTitle">
        Touren
      </v-toolbar-title>
    </v-toolbar>
    <v-divider class="headerDivider"/>
    <div style="padding-top: 20px; padding-bottom: 80px;" class="contentWrapper checkoutContent">

      <div style="margin-bottom: 60px;" v-if="files.length">
        <div class="tour-main-card" style="padding-top: 44px">
          <span class="text-h6" style="text-align: center;">Allgemeine Toureninfos</span>
        </div>
        <v-btn class="tour-nav-forward-btn"  @click="goToTourDocs">
          Zu den Dokumenten
          <v-icon>
            mdi-chevron-right
          </v-icon>
        </v-btn>
      </div>

      <div v-for="(tour, index) in tours"
           :key="index" style="margin-bottom: 40px;">
        <div class="tour-main-card">
          <span>{{tour.RouteNo}}</span>
          <span>{{tour.RouteDate}}</span>
          <span>{{tour.Description}}</span>
          <v-divider/>
          <span>Rollis: {{tour.NoOfRollis}}</span>
          <span>Rollis-TK: {{tour.NoOfRollisDF}}</span>
          <span>Rollis gesamt: {{ (tour.NoOfRollis ? tour.NoOfRollis : 0) + (tour.NoOfRollisDF ? tour.NoOfRollisDF : 0) }} / 27</span>
          <span>{{tour.internal_notes}}</span>
        </div>
        <v-btn class="tour-nav-forward-btn"  @click="openTourDetails(tour)">
          Tour ansehen
          <v-icon>
            mdi-chevron-right
          </v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import router from "@/router";

export default {
  name: 'WeeklyTourData',
  data() {
    return {
      tours: [],
      files: []
    }
  },
  async mounted() {
    const result = await axios.get('/api/tour-data/search')
    let data = result.data.data
    data = data.map(el => {
      el.RouteDate = new Date(el.RouteDate).toLocaleDateString('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      })
      return el
    })

    const docResult = await axios.get('/api/tour-data/tour-documents/files')
    this.tours.push(...data)
    this.files.push(...docResult.data)
  },
  methods: {
    goBack() {
      router.go(-1)
    },
    openTourDetails(tour) {
      router.push({name:'tourDetails', params: {id: tour.id}})
    },
    goToTourDocs() {
      router.push({name:'tourDocuments'})
    }
  }
}
</script>

<style src="./tours.css">

</style>
